import { getGlobal } from "@/functions/getGlobal";
import classes from "./styles.module.scss";
import { projects_helper } from "@/helpers/projects_helper";
import { convertDateFormat } from "@/functions/formatDate";
import Title from "@/ui/Title";
import Image from "@/ui/Image";
import Body from "@/ui/Body";
import QuoteSlider from "@/components/QuoteSlider";
import ProjectsSection from "@/components/ProjectsSection";
import SeoHead from "@/components/SeoHead";

export default function ProjectPage({ title, canonical, project }) {

  const global = getGlobal();
  return (
    <>
      <SeoHead title={title} canonical={canonical} />
      <main className={classes.cont}>
        <div className={classes.hero}>
          <Image img={project.image} size="1440x500" className={`${classes.bg_image}`} alt={project.name} />
          <div className={classes.overlay}></div>
          <div className={classes.header}>
            <Title title={`Project`} tag="h5" className={classes.subtitle} />
            <Title title={project.name} tag="h1" className={classes.title} />
          </div>
        </div>
        <div className={classes.content}>
          <div className={classes.left_cont}>
            <div className={classes.inner_cont}>
              <div className={classes.detail}>
                <Title title={`Category`} className={`caption ${classes.label}`} tag="div" />
                <Title title={project.category} className={classes.value} tag="h6" />
              </div>
              <div className={classes.detail}>
                <Title title={`Location`} className={`caption ${classes.label}`} tag="div" />
                <Title title={project.location} className={classes.value} tag="h6" />
              </div>
              <div className={classes.detail}>
                <Title title={`Project value`} className={`caption ${classes.label}`} tag="div" />
                <Title title={project.value} className={classes.value} tag="h6" />
              </div>
              <div className={classes.detail}>
                <Title title={`Date completed`} className={`caption ${classes.label}`} tag="div" />
                <Title title={project.completion_date ? convertDateFormat(project.completion_date) : "-"} className={classes.value} tag="h6" />
              </div>
            </div>
          </div>
          <div className={classes.right_cont}>
            <Body body={project.description} className={`body1 ${classes.body}`} />
          </div>
        </div>
        <QuoteSlider quotes={project.testimonials} />
        <ProjectsSection projects={projects_helper.fetch({limit: 3}) || []} title={"Our Projects"} />
      </main>
      
    </>
  );
}

export async function getStaticProps({ params: { url_slug } }) {
  const project = projects_helper.find(url_slug);

  return {
    props: {
      title: `${project.name} · Projects`,
      canonical: `/projects/${url_slug}`,
      project
    },
  };
}

export async function getStaticPaths() {
  return { paths: projects_helper.toPaths(), fallback: false };
}
